import React, { useMemo } from 'react';
import { AppButton, Box, Preloader, Text } from '@common-fe/common-fe';

import Item, { ItemProps } from './Item';

interface NodeProps {
  Item: React.FC<ItemProps>;
}

interface Props {
  text: string;
  disabled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
  testId?: string;
  children?: React.ReactNode;
}
const ExportButton: React.FC<Props> & NodeProps = ({
  testId = 'export',
  text,
  disabled,
  onClick,
  isLoading,
}) => {
  // const [isExpanded,setExpanded] = useState(false);
  // const handleToggleExpanded = useCallback(() => {
  //   setExpanded(!isExpanded);
  // }, [isExpanded]);
  // const ref = useRef(null);
  // useClickOutside(ref, () => {
  //   setExpanded(false);
  // });
  const content = useMemo(() => {
    if (isLoading) {
      return (
        <Box direction="row" align="center" data-testid={`${testId}_loading`}>
          <Text margin={{ right: 'spacing4' }}>Processing...</Text>
          <Preloader size={16} />
        </Box>
      );
    }
    return text;
  }, [isLoading, testId, text]);
  return (
    // <Box ref={ref} style={{position: 'relative'}}>
    <Box style={{ position: 'relative' }}>
      <AppButton width="180px" testId={testId} disabled={disabled || isLoading} onClick={onClick}>
        {content}
      </AppButton>
      {/* {isExpanded && (
        <Box
          round="container2Round"
          direction="column"
          elevation="active"
          background="canvas"
          pad={{vertical: 'spacing12', horizontal: 'spacing16'}}
          style={{position: 'absolute', top: '100%', right: 0, minWidth: '290px', zIndex: 100}}>

          <Text weight={400}>Reports are generated in accordance with the current filter settings.</Text>
          <Box height="1px" background="border1" margin={{vertical: 'spacing8'}} />
          {children}
        </Box>
      )} */}
    </Box>
  );
};

ExportButton.Item = Item;

export default ExportButton;
